import React from 'react';
import { TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../app/hooks';
import { updateVendorContact } from '../../../state/vendorSlice';

const SecondaryEmailEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentVendor } = useAppSelector(state => state.vendor);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateVendorContact({ secondaryEmail: event.target.value }));
  };

  return (
    <TextField
      label="Email"
      size="small"
      fullWidth
      type="email"
      value={currentVendor?.secondaryEmail || ''}
      onChange={handleChange}
    />
  );
};

export default SecondaryEmailEdit;
